const axios = require('axios')
const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')

const formBankData = is.getNode('.formBankData')
const spinnerBankData = is.getNode('.spinner-border')

const ignoreLastPage = () => {
  if (is.node('#inputIgnorarPagina')) {
    const ignoreValue = is.getNode('#inputIgnorarPagina').value

    if (ignoreValue == 1) {
      return true
    }
  }

  return false
}

if (is.node('.buttonSubmitBankData')) {
  listen('.buttonSubmitBankData', 'click', async (e) => {
    const trigger = e.delegateTarget || e.currentTarget
    trigger.disabled = true
    spinnerBankData.style.display = 'block'

    const nextUrl = is.getAttributeValue(trigger, 'nextUrl')
    const postUrl = is.getAttributeValue(trigger, 'postUrl')
    const nextStep = is.getAttributeValue(trigger, 'nextStep')

    let formData = new FormData(formBankData)

    if (is.checkVariable(ignoreLastPage())) {
      formData = new FormData()
      formData.append('codigo', is.getNode('input[name="codigo"]').value)
      formData.append('ignorar_pagina', is.getNode('#inputIgnorarPagina').value)
    }

    if (nextStep === 'submit') {
      formData = is.objectToFormData(sessionStorage, formData, null)
    }

    axios.post(postUrl, formData)
      .then(response => {
        if (is.checkVariable(response) && is.checkVariable(response.data) && is.checkVariable(response.data.request)) {
          saveInSession(response.data.request)
          window.location.href = nextUrl
          trigger.disabled = false
          spinnerBankData.style.display = 'none'
        }
      })
      .catch(error => {
        if (is.checkVariable(error) && is.checkVariable(error.response) && is.checkVariable(error.response.data) && is.checkVariable(error.response.data.errors)) {
          printErrorMessage(is.arrayFrom(error.response.data.errors))
          trigger.disabled = false
          spinnerBankData.style.display = 'none'
          console.log(error.response.data.errors)
        }
      })
  })

  if (is.checkVariable(ignoreLastPage())) {
    is.getNode('.buttonSubmitBankData').click()
  }
}

const saveInSession = data => {
  if (is.checkVariable(data)) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        sessionStorage.setItem(key, data[key])
      }
    }
  }
}

const printErrorMessage = messages => {
  if (!is.array(messages)) {
    return
  }

  const validationDiv = is.getNode('.validationDiv')
  validationDiv.innerHTML = ''
  validationDiv.style.display = 'block'
  const titleH4 = is.make('h4', { 'class': 'alert-heading noMarginTop' }, ['Por favor, verifique los siguientes campos'])
  const errorUl = is.make('ul')

  messages.forEach(element => {
    const errorLi = is.make('li', null, element)
    errorUl.appendChild(errorLi)
  })

  validationDiv.appendChild(titleH4)
  validationDiv.appendChild(errorUl)
  validationDiv.scrollIntoView()
}

if (is.node('#formEditBankData')) {
  const urlParameters = is.getParameterOfTheUrl(location.search)
  if (is.checkVariable(urlParameters.pagina) && urlParameters.pagina !== '1') {
    if (is.node(`#pillsPagina${urlParameters.pagina}tab`) && is.node('#pillsPagina1tab')) {
      const linkTab1 = is.getNode('#pillsPagina1tab')
      const linkTab = is.getNode(`#pillsPagina${urlParameters.pagina}tab`)

      is.removeClass(linkTab1, 'active')
      linkTab1.setAttribute('aria-selected', 'false')

      is.addClass(linkTab, 'active')
      linkTab.setAttribute('aria-selected', 'true')
    }

    if (is.node(`#pillsPagina${urlParameters.pagina}`) && is.node('#pillsPagina1')) {
      const tab1 = is.getNode('#pillsPagina1')
      const tab = is.getNode(`#pillsPagina${urlParameters.pagina}`)

      tab1.classList.remove('show', 'active')
      tab.classList.add('show', 'active')
    }
  }
}
